var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6879 41.454L49.2329 24.156L42.5909 28.386C41.2665 29.2305 39.6638 29.5219 38.1268 29.1977C36.5899 28.8735 35.2414 27.9595 34.3709 26.652L29.9999 20.085L25.6259 26.655C24.755 27.962 23.4063 28.8753 21.8694 29.199C20.3325 29.5226 18.73 29.2308 17.4059 28.386L10.7699 24.156L15.3149 41.454H44.6879ZM12.3779 21.624C10.0769 20.157 7.16995 22.278 7.86295 24.918L12.4109 42.216C12.5793 42.8571 12.9553 43.4244 13.4801 43.8293C14.0049 44.2342 14.6491 44.4539 15.3119 44.454H44.6879C45.3508 44.4539 45.995 44.2342 46.5198 43.8293C47.0446 43.4244 47.4206 42.8571 47.5889 42.216L52.1369 24.918C52.8269 22.278 49.9229 20.16 47.6219 21.624L40.9799 25.854C40.3181 26.2765 39.517 26.4227 38.7485 26.2612C37.9801 26.0996 37.3057 25.6433 36.8699 24.99L32.4959 18.42C32.222 18.0092 31.8508 17.6723 31.4154 17.4393C30.98 17.2063 30.4938 17.0844 29.9999 17.0844C29.5061 17.0844 29.0199 17.2063 28.5845 17.4393C28.1491 17.6723 27.7779 18.0092 27.5039 18.42L23.1299 24.99C22.6947 25.6438 22.0205 26.1007 21.252 26.2628C20.4835 26.4249 19.6822 26.2792 19.0199 25.857L12.3779 21.624Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.832 11.8351C32.8327 12.5869 32.5348 13.3084 32.0037 13.8406C31.4726 14.3728 30.7518 14.6723 30 14.6731C29.2481 14.6738 28.5267 14.3759 27.9944 13.8448C27.4622 13.3137 27.1627 12.5929 27.1619 11.8411C27.1612 11.0892 27.4591 10.3678 27.9902 9.83553C28.5213 9.3033 29.2421 9.00385 29.9939 9.00305C30.7458 9.00226 31.4672 9.30018 31.9995 9.83128C32.5317 10.3624 32.8312 11.0832 32.832 11.8351ZM55.4999 17.5081C55.5003 18.2599 55.202 18.9812 54.6707 19.5131C54.1393 20.0451 53.4183 20.3442 52.6664 20.3446C51.9146 20.3449 51.1933 20.0466 50.6614 19.5153C50.1294 18.9839 49.8303 18.2629 49.83 17.5111C49.83 16.7592 50.1286 16.0381 50.6603 15.5064C51.192 14.9747 51.9131 14.6761 52.6649 14.6761C53.4168 14.6761 54.1379 14.9747 54.6696 15.5064C55.2013 16.0381 55.4999 16.7562 55.4999 17.5081ZM10.1669 17.5081C10.1671 17.8804 10.094 18.249 9.95172 18.5931C9.80943 18.9371 9.60077 19.2497 9.33766 19.5131C9.07454 19.7765 8.76212 19.9855 8.41824 20.1282C8.07436 20.2708 7.70575 20.3444 7.33345 20.3446C6.96115 20.3447 6.59246 20.2716 6.24843 20.1293C5.90439 19.987 5.59175 19.7784 5.32836 19.5153C5.06497 19.2521 4.85598 18.9397 4.71332 18.5958C4.57067 18.252 4.49715 17.8834 4.49695 17.5111C4.49695 16.7592 4.79564 16.0381 5.3273 15.5064C5.85897 14.9747 6.58006 14.6761 7.33195 14.6761C8.08384 14.6761 8.80493 14.9747 9.3366 15.5064C9.86826 16.0381 10.1669 16.7562 10.1669 17.5081Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 48C15.75 47.6022 15.908 47.2206 16.1893 46.9393C16.4706 46.658 16.8522 46.5 17.25 46.5H43.461C43.8588 46.5 44.2404 46.658 44.5217 46.9393C44.803 47.2206 44.961 47.6022 44.961 48C44.961 48.3978 44.803 48.7794 44.5217 49.0607C44.2404 49.342 43.8588 49.5 43.461 49.5H17.25C16.8522 49.5 16.4706 49.342 16.1893 49.0607C15.908 48.7794 15.75 48.3978 15.75 48Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_673",
    x: -4,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_673",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultRank);
export default __webpack_public_path__ + "static/media/resultRank.6498a7eea548e13bac4632771a04141d.svg";
export { ForwardRef as ReactComponent };